module.exports = __webpack_public_path__ + "static/media/facebook.d5455313.svg";